import { useCallback, useMemo, useState } from 'react';

/**
 * Session-only toggle: hides player1 dev UI until the page is refreshed.
 */
export function useHideDevElementsForScreenshot() {
  const [hidden, setHidden] = useState(false);
  const hide = useCallback(() => {
    setHidden(true);
  }, []);

  return useMemo(
    () => ({
      hidden,
      hide,
      showDevControls: !hidden,
    }),
    [hidden, hide]
  );
}
